import { useTranslation } from "react-i18next";
import { usePeopleSearch } from "@/contexts/PeopleSearchContext";
import { ChipsInput } from "../ChipsInput";

export function LocationPanel() {
	const { t } = useTranslation();
	const { draft, updateDraft } = usePeopleSearch();

	return (
		<div className="space-y-4">
			<p className="text-sm text-muted-foreground">
				{t("peopleSearch.location.hint", "Candidates located in any of these places")}
			</p>
			<ChipsInput
				values={draft.location.values}
				onChange={values => updateDraft('location', { values })}
				placeholder={t("peopleSearch.location.placeholder", "Add a city, region or country")}
			/>
		</div>
	);
}
